const modal = document.querySelectorAll('.modal-custom');
modal?.forEach((modalElement) => {
  modalElement.addEventListener('click', (event) => {
    event.preventDefault();
    const modalId = modalElement.getAttribute('data-modal');
    const modalContent = document.getElementById(modalId);
    modalContent?.classList.toggle('show');
    const modalHidden = modalContent?.querySelector('.close-modal');
    modalHidden?.addEventListener('click', function () {
      modalContent?.classList.remove('show');
    });
  });
});

const modalNotification = document.querySelectorAll('.modal--popup');

modalNotification?.forEach((modalElement) => {
  const modalHidden = modalElement.querySelectorAll('.close-modal');
  modalHidden?.forEach((modalElementItem) => {
    modalElementItem?.addEventListener('click', function (event) {
      event.preventDefault();
      modalElement?.classList.remove('show');
    });
  });
});
